// Dependencies
window.$ = window.jQuery = require('jquery');

require('../_lib/error-handling');

window.toastr = require('toastr/toastr');
window.NProgress = require('nprogress');

require('jquery-ui-dist/jquery-ui');
window.DataTable = require('datatables.net');
require('select2');
require('jquery-form');
require('bootstrap');
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.es');
require('bootstrap-editable');
require('cookieconsent');
require('jquery-ui.combobox');
require('../_lib/formatUnicorn');
require('../_lib/add-class-when-visible');

// Local dependencies
const Router = require('../_lib/core/Router');
window.latinize = require('../_lib/latinize');
window.md5 = require('../_lib/md5.min');
window.bootbox = require('../_lib/bootbox.min');
window.__ = require('../_lib/translate');

require('../_lib/jquery.language.switcher');
require('../_lib/jquery.donetyping');
require('../_lib/jquery.fileDownload');
require('../_lib/jquery.tagsinput');
require('../_lib/scrollup/jquery.scrollUp');
require('../_lib/formData');
require('../_lib/ajaxForm');
require('../_lib/loading');
require('../_lib/chosen.jquery.min');

require('../_common');

// Load all src js
new Router(() => [
  require.context('../app/src', true, /.js$/),
  require.context('../common/src', true, /.js$/)
]);

// Load all react files
const reactContext = require.context('../../react/src/app', true, /.jsx$/);
reactContext.keys().forEach((fileName) => {
  reactContext(fileName);
});
